import { languageManager, type Language } from './languageManager';

export interface I18nText {
    en: string;
    id: string;
    ko: string;
}

export type I18nMap = { [key: string]: Partial<I18nText> };

/**
 * Creates a translation function for a given set of translations.
 * Pre-compiles all language versions at creation time for O(1) lookup performance.
 * Automatically uses the current language from languageManager.
 */
export function createI18n(translations: I18nMap) {
    // Pre-compile all translations for all languages
    const compiled: Record<Language, Record<string, string>> = {
        en: {},
        id: {},
        ko: {}
    };

    // Build lookup tables for each language
    for (const [key, translation] of Object.entries(translations)) {
        compiled.en[key] = translation?.en || key;
        compiled.id[key] = translation?.id || translation?.en || key;
        compiled.ko[key] = translation?.ko || translation?.en || key;
    }

    // Return translation function that automatically uses current language
    return (key: string): string => {
        const lang = languageManager.getLanguage();
        return compiled[lang]?.[key] || compiled.en[key] || key;
    };
}